/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */

import { type ProgrameeTyping, type TimeframeTyping } from '@/typings/widget';
import { type IdTyping, type IriTyping } from '@shared/typings';
import { type ComputedRef, type Ref } from 'vue';

// eslint-disable-next-line max-lines-per-function, max-statements
export const useWidgetPathStore = defineStore('path', () => {
    const { t } = useI18n();

    // Constants
    // Computed so timeframe names re-translate reactively when the locale changes
    const TIMEFRAMES: ComputedRef<TimeframeTyping[]> = computed(() => [
        {
            id: 1,
            name: t('widget.quote.timeframes.morning'),
            image: `${import.meta.env.VITE_CDN_URL}/static/illu_morning.svg`,
            hoverImage: `${import.meta.env.VITE_CDN_URL}/static/illu_morning_color.svg`,
        },
        {
            id: 2,
            name: t('widget.quote.timeframes.afternoon'),
            image: `${import.meta.env.VITE_CDN_URL}/static/illu_afternoon.svg`,
            hoverImage: `${import.meta.env.VITE_CDN_URL}/static/illu_afternoon_color.svg`,
        },
        {
            id: 3,
            name: t('widget.quote.timeframes.evening'),
            image: `${import.meta.env.VITE_CDN_URL}/static/illu_evening.svg`,
            hoverImage: `${import.meta.env.VITE_CDN_URL}/static/illu_evening_color.svg`,
        },
        {
            id: 4,
            name: t('widget.quote.timeframes.whole-day'),
            image: `${import.meta.env.VITE_CDN_URL}/static/illu_day.svg`,
            hoverImage: `${import.meta.env.VITE_CDN_URL}/static/illu_day_color.svg`,
        },
        {
            id: 5,
            name: t('widget.quote.timeframes.multiday'),
            image: `${import.meta.env.VITE_CDN_URL}/static/illu_multipleday.svg`,
            hoverImage: `${import.meta.env.VITE_CDN_URL}/static/illu_multipleday_color.svg`,
        },
    ]);

    // State
    const step: Ref<number> = ref(-1);
    const bookerName: Ref<string> = ref('');
    const eventTypeId: Ref<IdTyping> = ref(0);
    const selectedPath: Ref<string> = ref('');
    const selectedDate: Ref<string> = ref('');
    const surveyOrganizer: Ref<string> = ref('');
    const surveyTheme: Ref<string> = ref('');
    const surveyAppointment: Ref<string> = ref('');
    const guestAmount: Ref<number> = ref(0);
    const guestTypeIds: Ref<IdTyping[]> = ref([]);
    const descriptionIds: Ref<IdTyping[]> = ref([]);
    const budgetAmount: Ref<number> = ref(0);
    const appointment: Ref<string> = ref('');
    const appointmentDate: Ref<string> = ref('');
    const timeframeId: Ref<IdTyping> = ref(0);
    const templateId: Ref<IriTyping> = ref('');
    const pathAlreadySelected: Ref<boolean> = ref(false);
    const program: Ref<ProgrameeTyping[]> = ref([]);
    const decorationId: Ref<IdTyping> = ref(0);
    const entertainmentId: Ref<IdTyping> = ref(0);
    const productCategoryId: Ref<IdTyping> = ref(0);
    const spaceIds: Ref<IdTyping[]> = ref([]);
    const productIds: Ref<IdTyping[]> = ref([]);

    // Actions
    const resetPathStore = (): void => {
        step.value = -1;
        eventTypeId.value = 0;
        guestAmount.value = 0;
        budgetAmount.value = 0;
        timeframeId.value = 0;
        productCategoryId.value = 0;
        decorationId.value = 0;
        entertainmentId.value = 0;
        bookerName.value = '';
        selectedPath.value = '';
        selectedDate.value = '';
        surveyOrganizer.value = '';
        surveyTheme.value = '';
        surveyAppointment.value = '';
        appointment.value = '';
        appointmentDate.value = '';
        templateId.value = '';
        descriptionIds.value = [];
        guestTypeIds.value = [];
        program.value = [];
        spaceIds.value = [];
        productIds.value = [];
        pathAlreadySelected.value = false;
    };

    return {
        TIMEFRAMES,

        // State
        bookerName,
        step,
        eventTypeId,
        selectedPath,
        selectedDate,
        surveyOrganizer,
        surveyTheme,
        surveyAppointment,
        guestAmount,
        guestTypeIds,
        descriptionIds,
        budgetAmount,
        appointment,
        appointmentDate,
        timeframeId,
        templateId,
        productCategoryId,
        program,
        spaceIds,
        decorationId,
        entertainmentId,
        productIds,
        pathAlreadySelected,

        // Actions
        resetPathStore,
    };
});
